var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6919 0.183058C14.936 0.427136 14.936 0.822864 14.6919 1.06694L5.94194 9.81694C5.69786 10.061 5.30214 10.061 5.05806 9.81694L0.683058 5.44194C0.438981 5.19786 0.438981 4.80214 0.683058 4.55806C0.927136 4.31398 1.32286 4.31398 1.56694 4.55806L5.5 8.49112L13.8081 0.183058C14.0521 -0.0610194 14.4479 -0.0610194 14.6919 0.183058Z",
    fill: "#313335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkBlack);
export default __webpack_public_path__ + "static/media/checkmark-black.82f9190d61c3b2ad14ca12037b6f06b7.svg";
export { ForwardRef as ReactComponent };